import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { PiArrowLeftBold } from "react-icons/pi";
import { Link, useParams } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import { dataDecrypt, dataEncrypt } from '../app/utils/encryption-helper';
import LoginOtp from './login-screen';
import { useSelector } from 'react-redux';
import LOGO from './../assets/images/vyapar_live_main_logo.png';
import { ApisService } from '../app/core/apis.service';
import { AppConfig } from '../app/config';
import { formatDateTimeInIST } from '../components/indiaDateFormate';
import { TransactionDetailsUI } from '../components/transaction-details-ui';
export const Delivery = () => {
  const [DeliveryData, setDeliveryData] = useState<any>([]);
  const [backRouteLink, setBackRouteLink] = useState('');
  const [otpReference, setOtpReference] = useState('');
  const userData = useSelector((state: any) => state)
  const routerParams = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  //time 
  function formatTimestamp(timestamp: number): string {
    const dateObj = new Date(timestamp);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
  }
  const created_date: string = formatTimestamp(DeliveryData[0]?.invoice_details?.invoice_date);
  console.log(created_date);

  useEffect(() => {
    loadDelivery();
  }, []);

  async function loadDelivery(): Promise<void> {
    setLoading(true);
    try {
      const res = await ApisService.getTransactionData('finInvoiceById', routerParams.id || '');
      const data: any = res.data.data;
      setLoading(false);
      const transactionData = JSON.parse(dataDecrypt(data));
      setDeliveryData(transactionData);
      if (transactionData[0]?.transactionId) {
        setBackRouteLink(dataEncrypt(JSON.stringify({ id: transactionData[0].transactionId })));
        const preparedReference = dataEncrypt(JSON.stringify({ invoice: transactionData[0].id, id: transactionData[0].transactionId, type: 'delivery' }));
        setOtpReference(preparedReference);
      }
    } catch (error) {
      setLoading(false);
    }
  }
  return (
    <div>
      {(!userData || !userData?.UserDataReducer || !userData?.UserDataReducer?.otp) && <LoginOtp reference={otpReference} />}
      {userData?.UserDataReducer?.otp && <>
        <div className='d-flex justify-content-between p-3 align-items' style={{ backgroundColor: "#274472", color: "white" }}>
          <Link to={`/order/${backRouteLink}`}> <span ><PiArrowLeftBold size={22} className='text-white' /></span></Link>
          <span style={{ lineHeight: "0", textAlign: "center" }}><h4>Delivery Details</h4><div>{('currency_symbol' in (DeliveryData[0]?.buyer || {})) ? (
            <>{DeliveryData[0]?.buyer?.name}</>
          ) : ('currency_symbol' in (DeliveryData[0]?.seller || {})) ? (
            <>{DeliveryData[0]?.seller?.name}</>
          ) : (
            <p></p>
          )}</div></span>
          <img src={LOGO} alt="" height={60} />
        </div>
        <br />

        {!loading ? <div className='container-fluid'>
          <div style={{ backgroundColor: "white", borderRadius: "3px" }}>
            {/* <Card className='box-shadow rounded-4 '>
              <Card.Body className='p-2'>
                <div className='row text-center'>
                  <div className='col-md-4 my-2 light-grey-right-border'>
                    <h6 className='mb-0'>Seller</h6>
                    <span>{DeliveryData[0]?.seller?.name}</span>
                  </div>
                  <div className='col-md-4 my-2 light-grey-right-border'>
                    <h6 className='mb-0'>Txn Date</h6>
                    <span>{formatDateTimeInIST(DeliveryData[0]?.invoice_details?.invoice_date)}</span>
                  </div>
                  <div className='col-md-4 my-2'>
                    <h6 className='mb-0'>Txn Id</h6>
                    <span>{DeliveryData[0]?._id}</span>
                  </div>
                </div>
              </Card.Body>
            </Card> */}
            <TransactionDetailsUI data={[{ header: 'Seller', value: DeliveryData[0]?.seller?.name }, { header: 'Txn Date', value: formatDateTimeInIST(DeliveryData[0]?.invoice_details?.invoice_date) }, { header: 'Txn Id', value: DeliveryData[0]?._id }]} />
          </div>

          {/* <h5 className='text-center mt-4 mb-3'><span style={{ backgroundColor: "#274472" }} className='text-light p-2 px-4 rounded-4'>Direct Delivery</span></h5> */}
          {DeliveryData[0]?.invoice_details?.order_track ? <div>
            <div className='row my-2 align-items'>
              <div className='col-6'><b>Invoice No: {DeliveryData[0]?.invoice_number}</b></div>
              <div className='col-6 text-end'><a target='_blank' href={`${AppConfig.BASE_URL}/pdfs/${DeliveryData[0]?.transactionId}/invoice-pdf/${DeliveryData[0]?.invoice_details?.bill_no}`}>
                view invoice
              </a></div>
            </div>
            <div className='card box-shadow rounded-4 border-0 p-2 fs-14 mt-2'>
              <div className='card.body'>
                <div className='row px-2 py-1 align-items'>
                  <h6 className='col-6 fw-semibold fs-14 mb-0'>Business Unit</h6>
                  <div className='col-6'>: {DeliveryData[0]?.invoice_details?.order_track?.assigned_to_bu}</div>
                </div>
                <div className='row px-2 py-1 align-items'>
                  <h6 className='col-6  fw-semibold fs-14 mb-0'>Contact Persion</h6>
                  <div className='col-6'>: {DeliveryData[0]?.invoice_details?.order_track?.assigned_to_user}</div>
                </div>
                <div className='row px-2 py-1 align-items'>
                  <h6 className='col-6  fw-semibold fs-14 mb-0'>Contact Number</h6>
                  <div className='col-6'>: {DeliveryData[0]?.invoice_details?.order_track?.assigned_user_mobile_number}</div>
                </div>
                <div className='row px-2 py-1 align-items'>
                  <h6 className='col-6  fw-semibold fs-14 mb-0'>Expected Delivery Date</h6>
                  <div className='col-6'>: {DeliveryData[0]?.invoice_details?.order_track?.delivery_date}</div>
                </div>
                <div className='row px-2 py-1 align-items'>
                  <h6 className='col-6  fw-semibold fs-14 mb-0'>Expected Delivery Time</h6>
                  <div className='col-6'>: {DeliveryData[0]?.invoice_details?.order_track?.delivery_time}</div>
                </div>
                <div className='row px-2 py-1 align-items'>
                  <h6 className='col-6  fw-semibold fs-14 mb-0'>Status</h6>
                  <div className='col-6'>: <span className={`p-1 px-2 text-white rounded-4 fs-14 ${DeliveryData[0]?.invoice_details?.order_track?.delivery_status === 'Completed' ? "bg-success" : "primary-background"}`}>{DeliveryData[0]?.invoice_details?.order_track?.delivery_status}</span></div>
                </div>
                {DeliveryData[0]?.invoice_details?.order_track?.GRN_No && <div className='row px-2 pt-1 align-items'>
                  <h6 className='col-6  fw-semibold fs-14 mb-0'>GRN No</h6>
                  <div className='col-6'>: {DeliveryData[0]?.invoice_details?.order_track?.GRN_No}</div>
                </div>}
              </div>
            </div>
            <h5 style={{ color: "#274472" }} className='my-2 mt-4 fs-16 fw-bold' >Tracking Details</h5>
            <div className='card mb-2 box-shadow rounded-4 border-0 p-1'>
              <div className='card.body'>
                <div className='row px-2 py-1 align-items'>
                  <h6 className='col-6  fw-semibold fs-14 mb-0'>Document Type</h6>
                  <div className='col-6'>: {DeliveryData[0]?.invoice_details?.order_track?.delivery_details_arr[0]?.delivery_type}</div>
                </div>
                <div className='row px-2 py-1 align-items'>
                  <h6 className='col-6  fw-semibold fs-14 mb-0'>Document Number</h6>
                  <div className='col-6'>: {DeliveryData[0]?.invoice_details?.order_track?.delivery_details_arr[0]?.value}</div>
                </div>
                {/* <div className='row px-2 pt-2'>
                  <h6 className='col-6' style={{ color: "#274472" }}> Document Type</h6>
                  <div className='col-6'>: {DeliveryData[0]?.invoice_details?.order_track?.delivery_details_arr[0]?.delivery_type}</div>
                </div>
                <div className='row px-2 pt-1'>
                  <h6 className='col-6' style={{ color: "#274472" }}> Document Number</h6>
                  <div className='col-6'>: {DeliveryData[0]?.invoice_details?.order_track?.delivery_details_arr[0]?.value}</div>
                </div> */}
              </div>
            </div>
            {DeliveryData[0]?.invoice_details?.order_track?.delivery_image && <div className="row mt-4 align-items-center">
              <h5 className='col-12 my-2 mt-2 fs-16 fw-bold' style={{ color: "#274472" }}>Delivery Image</h5>
              <div className="col-md-4"></div>
              <div className="col-md-4 text-center">
                <img
                  src={`${AppConfig?.IMAGE_PATH}${DeliveryData[0]?.invoice_details?.order_track?.delivery_image}`}
                  className='w-100 rounded'
                  alt="Packing"
                  style={{ cursor: 'pointer', height: '200px', objectFit: 'scale-down' }}
                  onClick={() => window.open(`${AppConfig?.IMAGE_PATH}${DeliveryData[0]?.invoice_details?.order_track?.delivery_image}`, '_blank')}
                />
              </div>
              <div className='col-md-4'></div>
            </div>}
          </div> : <h4 className='text-center mt-3 fw-bold'>Delivery Details Not Updated</h4>}
          <div className='text-center'>
            <Link to={`/order/${backRouteLink}`}><button className='px-4 py-2 rounded my-2 fs-14'>Track All Steps of This Transaction</button></Link>
          </div>
        </div> : <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <div className="spinner-border text-secondary" role="status"></div>
        </div>}
      </>}
    </div>
  )
}